/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { IMintTo, IMintToInterface } from "../IMintTo";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "mintTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IMintTo__factory {
  static readonly abi = _abi;
  static createInterface(): IMintToInterface {
    return new utils.Interface(_abi) as IMintToInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IMintTo {
    return new Contract(address, _abi, signerOrProvider) as IMintTo;
  }
}
